import { render, staticRenderFns } from "./humanAidPoject.vue?vue&type=template&id=5747de93&scoped=true&"
import script from "./humanAidPoject.vue?vue&type=script&lang=js&"
export * from "./humanAidPoject.vue?vue&type=script&lang=js&"
import style0 from "./humanAidPoject.vue?vue&type=style&index=0&id=5747de93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747de93",
  null
  
)

component.options.__file = "humanAidPoject.vue"
export default component.exports